export function toNormalized(
    clientX: number,
    clientY: number,
    base: DOMRect,
    width: number,
    height: number
) {
    return {
        nx: (clientX - base.left) / width,
        ny: (clientY - base.top) / height,
        px: clientX - base.left,
        py: clientY - base.top,
    };
}

export function pointsToSvg(points: Array<{ x: number; y: number }>, width: number, height: number) {
    return points.map((p) => `${p.x * width},${p.y * height}`).join(' ');
}
